import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Login successful!');
      navigate('/admin');
    } catch (error) {
      const errorMsg = typeof error.response?.data?.detail === 'string'
        ? error.response.data.detail
        : 'Invalid credentials';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: '#0F2942' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <h1
            className="text-4xl md:text-5xl font-light tracking-tight mb-4 text-white"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Admin Login
          </h1>
          <div className="w-12 h-px mx-auto mb-4" style={{ backgroundColor: '#D4820A' }} />
          <p className="text-base" style={{ color: 'rgba(240, 235, 226, 0.5)' }}>Manage cultural opportunities</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 p-8 bg-white rounded-xl shadow-lg">
          <div>
            <label className="text-sm font-medium mb-2 block" style={{ color: '#0F2942' }}>Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="rounded-lg"
              placeholder="admin@culturecareers.org"
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="text-sm font-medium mb-2 block" style={{ color: '#0F2942' }}>Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="rounded-lg"
              data-testid="admin-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg px-6 py-3 font-medium"
            style={{ backgroundColor: '#0F2942', color: '#FFFFFF' }}
            data-testid="admin-login-submit"
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <div className="text-center mt-8">
          <Link to="/" className="text-sm hover:underline" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="back-home-link">
            &larr; Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
